import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const cityApi = createApi({
  reducerPath: "city",
  tagTypes: ["Cities"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    getCities: builder.query({
      query: (search: string) => {
        const query = search ? `?search=${search}` : "";
        return `api/v2/cities${query}`;
      },
      transformResponse: (response: any) => {
        return response.cities;
      }
    })
  })
});

export const { useGetCitiesQuery } = cityApi;
